import React, { useState } from "react";
import { Container, Button, Form } from "react-bootstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { GlobalSpinner, PDFHeader } from "../../../../../global/globalFunctions";
import MaterialTable from 'material-table';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
// import moment from "moment";


const TrailSearch = (props) => {
    const [showOpeningBalance, setShowOpeningBalance] = useState(true);
    const [showDuringTransaction, setShowDuringTransaction] = useState(true);
    const [showClosingBalance, setShowClosingBalance] = useState(true);

    // Calculate column totals
    const calculateTotals = () => {
        let totals = {
            opening_balance_debit: 0,
            opening_balance_credit: 0,
            during_debit: 0,
            during_credit: 0,
            closing_balance_debit: 0,
            closing_balance_credit: 0
        };

        props.trailBalanceList.forEach(row => {
            if (row.opening_balance_sign === 2) totals.opening_balance_debit += row.opening_balance;
            if (row.opening_balance_sign === 1) totals.opening_balance_credit += row.opening_balance;
            totals.during_debit += row.debitSum;
            totals.during_credit += row.creditSum;
            if (row.closing_balance_sign === 2) totals.closing_balance_debit += row.closing_balance;
            if (row.closing_balance_sign === 1) totals.closing_balance_credit += row.closing_balance;
        });

        return totals;
    };

    const totals = calculateTotals();

    const columns = [
        {
            title: "Name", field: "levelFourName",
            render: rowData => rowData.isTotalRow ? <b>Total</b> : `${rowData.allLevelKey} - ${rowData.levelFourName}`,
            cellStyle: { width: '20%', fontWeight: "bold" }
        },
        ...(showOpeningBalance ? [
            {
                title: "Opening Debit", field: "opening_balance_debit",
                render: rowData => rowData.isTotalRow ? <b>{totals.opening_balance_debit.toLocaleString()}/-</b>
                    : (rowData.opening_balance_sign === 2 ? `${rowData.opening_balance.toLocaleString()}/-` : `0/-`)
            },
            {
                title: "Opening Credit", field: "opening_balance_credit",
                render: rowData => rowData.isTotalRow ? <b>{totals.opening_balance_credit.toLocaleString()}/-</b>
                    : (rowData.opening_balance_sign === 1 ? `${rowData.opening_balance.toLocaleString()}/-` : `0/-`)
            }
        ] : []),
        ...(showDuringTransaction ? [
            {
                title: "During Debit", field: "during_debit",
                render: rowData => rowData.isTotalRow ? <b>{totals.during_debit.toLocaleString()}/-</b>
                    : `${rowData.debitSum.toLocaleString()}/-`
            },
            {
                title: "During Credit", field: "during_credit",
                render: rowData => rowData.isTotalRow ? <b>{totals.during_credit.toLocaleString()}/-</b>
                    : `${rowData.creditSum.toLocaleString()}/-`
            }
        ] : []),
        ...(showClosingBalance ? [
            {
                title: "Closing Debit", field: "closing_balance_debit",
                render: rowData => rowData.isTotalRow ? <b>{totals.closing_balance_debit.toLocaleString()}/-</b>
                    : (rowData.closing_balance_sign === 2 ? `${rowData.closing_balance.toLocaleString()}/-` : `0/-`)
            },
            {
                title: "Closing Credit", field: "closing_balance_credit",
                render: rowData => rowData.isTotalRow ? <b>{totals.closing_balance_credit.toLocaleString()}/-</b>
                    : (rowData.closing_balance_sign === 1 ? `${rowData.closing_balance.toLocaleString()}/-` : `0/-`)
            }
        ] : [])
    ];

    // Append the total row to the data
    const tableData = [...props.trailBalanceList, { isTotalRow: true }];

    return (
        <>
            {props.isFetchingTrailBalance ? (
                <GlobalSpinner />
            ) : (
                <Container fluid>
                    <div className="sendDiv">
                        <Link to="/accountsModule/TrailBalance">
                            <Button><b>BACK TO SEARCH</b></Button>
                        </Link>
                    </div>

                    {/* Section Selection Checkboxes */}
                    <div className="mb-3 d-flex gap-3">
                        <Form.Check
                            type="switch"
                            id="opening-balance-switch"
                            label="Opening Balance"
                            checked={showOpeningBalance}
                            onChange={() => setShowOpeningBalance(!showOpeningBalance)}
                            className="custom-switch"
                        />
                        <Form.Check
                            type='switch'
                            id="during-transaction-switch"
                            label="During Transaction"
                            checked={showDuringTransaction}
                            onChange={() => setShowDuringTransaction(!showDuringTransaction)}
                            className="custom-switch"
                        />
                        <Form.Check
                            type="switch"
                            id="closing-balance-switch"
                            label="Closing Balance"
                            checked={showClosingBalance}
                            onChange={() => setShowClosingBalance(!showClosingBalance)}
                            className="custom-switch"
                        />
                    </div>

                    {/* Trial Balance Table */}
                    <MaterialTable
                        title="Trial Balance"
                        columns={columns}
                        data={tableData}
                        options={{
                            actionsColumnIndex: -1,
                            exportButton: true,
                            paging: true,
                            pageSize: 50,
                            emptyRowsWhenPaging: false,
                            pageSizeOptions: [50, 100, 150, 200],
                            headerStyle: {
                                position: "sticky",
                                top: 0,
                                color: "#00BBBB",
                                fontWeight: "550",
                                whiteSpace: 'nowrap',
                            },
                            cellStyle: {
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                fontSize: "13px",
                                padding: "6px 10px",
                                border: "1px solid #ddd"
                            },
                            rowStyle: rowData => rowData.isTotalRow ? {
                                fontSize: "14px",
                                fontWeight: "bold",
                                backgroundColor: "#f2f2f2",
                                borderTop: "2px solid #000"
                            } : {
                                fontSize: "13px",
                                padding: "6px 10px",
                                borderBottom: "1px solid #ddd",
                                backgroundColor: "#fff"
                            },
                            exportPdf: (columns, data) => {
                                const unit = "pt";
                                const size = "A4";
                                const orientation = "l";
                                const doc = new jsPDF(orientation, unit, size);
                                PDFHeader(doc, "Trail Balance Report");




                                doc.setProperties({ title: `Trail Balance Report.pdf` });
                                const blob = doc.output("blob");
                                window.open(URL.createObjectURL(blob));
                            }
                        }}
                    />
                </Container>
            )}
        </>
    );
};

const mapStateToProps = (state) => ({
    trailBalanceList: state.TrailBalanceReducer.trailBalanceList,
    isFetchingTrailBalance: state.TrailBalanceReducer.isFetchingTrailBalance,
});

export default connect(mapStateToProps)(TrailSearch);